import { FC } from "react";

import { InsurancePolicy, LifePossession } from "../../../../../../../shared/interfaces";
import { Column, _renderColumns } from "../../../../utils/renderSections";
import { formatDate, formattedPrice } from "../../../../../../../shared/utils";
import { CollapsableSections } from "../";
import { RowSize } from "../../../../../../../shared/components";


interface LifePossessionsCollapsableProps {
    possessionInfo: LifePossession;
    insurancePolicyDetail: InsurancePolicy;
}

export const LifePossessionsCollapsable: FC<LifePossessionsCollapsableProps> = ({ possessionInfo, insurancePolicyDetail }) => {

    const generatePersonalData = (): Array<Column> => ([
        {
            label: 'Integrante',
            value: possessionInfo.integrVida,
        },
        {
            label: 'Documento',
            value: `${ possessionInfo.tipDocVida } ${ possessionInfo.nroDocVida }`,
        },
        {
            label: 'F. Nacimiento',
            value: formatDate( possessionInfo.fecNacVida ),
        },
        {
            label: 'Suma Asegurada',
            value: `$${ formattedPrice( possessionInfo.sumAseVida ) }`,
        },
        {
            label: 'Fecha Ingreso',
            value: formatDate( possessionInfo.fecIngVida ),
        },
        {
            label: 'Fecha Egreso',
            value: formatDate( possessionInfo.fecEgrVida ),
        },
        {
            label: 'CUIL',
            value: possessionInfo.numeroCuil,
        },
        {
            label: 'Género',
            value: possessionInfo.genero,
        },
    ]);

    const generateProducts = (): Array<Column> =>  [
        {
            label: 'Producto',
            value: possessionInfo.producVida,
            valueInBold: true,
            columnSize: {
                lg: { span: 24 },
                sm: { span: 24 },
                xs: { span: 24 }
            }
        },
        ...possessionInfo.coberturas.map(({ nombreCob, sumaCob }) => ({
            label: nombreCob,
            value: `${ insurancePolicyDetail.moneda } ${ formattedPrice( sumaCob ) }`
        }))
    ]
    
    return (
        <>
            <CollapsableSections 
                title="Datos personales"
                children={  
                    <RowSize rowProps={{gutter:[0 , 10]}} >
                        { _renderColumns( generatePersonalData() ) }
                    </RowSize> 
                }
            />

            <CollapsableSections 
                title="Productos y Coberturas"
                children={
                    <RowSize rowProps={{gutter:[0 , 10]}} >
                        { _renderColumns(generateProducts()) }
                    </RowSize>
                }
            />
        </>
    )
}